import { Injectable } from "@angular/core";
import { UserService } from '../../services/user/user.service';
import { Router } from "@angular/router";

@Injectable()
export class AclService {

  roleSections = [];
  user: any;
  accessName = "";
  accessPerm = "";
  accessLoad = false;

  constructor(
    private userService: UserService,
    public router: Router
  ) {
  }

  isUserSubscribed() {
    if (this.user.isPackagePurchased == 1) {
      return true;
    } else {
      return false;
    }
  }

  getUserRoles(module) {
    this.user = this.userService.getLoggedInUser();
    if (!this.user.role) {
      //using few components in public view also where
      //we have used acl directive
      //we want it should show commponent properly
      this.user.role = {
        modules: []
      }
      this.user.isPackagePurchased = 0;
    }
    this.user.role.modules.forEach((v, i) => {
      this.roleSections.push(v.name)
    })
    return this.returnAccess(module);
  }

  checkAccess(acl) {
    let tempAcl = acl.split(":");
    this.accessName = tempAcl[0];
    this.accessPerm = (typeof tempAcl[1] == "undefined" ? "read" : tempAcl[1]);
    if (tempAcl[2] == "undefined" || tempAcl[2] == "") {
      this.accessLoad = false;
    }
    if (tempAcl[2] == "true") {
      this.accessLoad = true
    }
    //if user has access for all sections then set accessName to 'all'
    if (this.roleSections.includes("all")) {
      this.accessName = "all";
    }
    if (this.roleSections.includes(this.accessName) || this.roleSections.includes("all")) {
      let hasAccess = false;
      //check permission for sections
      this.user.role.modules.forEach((v, i) => {
        if (v.name == this.accessName) {
          let p = ["read"];
          if (v.grantPermission == "write") {
            p.push(v.grantPermission);
          }
          //if user has write permission OR user has read permission and want to access a section with write permission
          if (p.includes(this.accessPerm) || (this.accessPerm == "no-write" && v.grantPermission != "write")) {
            hasAccess = true;
          }
        }
      })
      return hasAccess;
    } else {
      return false;
    }
  }

  checkModuleAccess(module) {
    return this.getUserRoles(module);

  }

  returnAccess(module) {
    let hasSubscription = this.isUserSubscribed()
    let hasAccess = this.checkAccess(module);
    if (!hasSubscription || !hasAccess) {
      return false;
    } else {
      return true;
    }
  }
}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/acl/acl.service.ts